export interface GetClosedDaysRequest {
  branchCode: string
  year: string
  month: string
}

export function GetClosedDaysRequestToJSON(value: GetClosedDaysRequest): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    year: value.year !== '' ? value.year : undefined,
    month: value.month !== '' ? value.month : undefined
  }
}
